import { botRequest } from './bot_service';

// Binance alerts are evaluated server-side (10/account) against the shared
// all-symbols ticker feed and fire even while this tab is closed. The other
// free crypto exchanges (Coinbase/Kraken/Bybit/OKX) get the same treatment
// via server/exchanges/combined_feed.js, which opens a live ticker
// subscription per alerted symbol. Non-crypto connectors have no
// server-side feed, so those stay UI-level (model.mjs).
const SERVER_ALERT_CONNECTORS = ['Binance', 'Coinbase', 'Kraken', 'Bybit', 'OKX'];
export const isServerAlertConnector = (connector) => SERVER_ALERT_CONNECTORS.includes(connector);

// Maps a chart connector to the `exchange` field the /api/alerts POST body
// expects. Binance is the server's default when `exchange` is omitted, so
// it's left out here for backward compatibility with existing alerts.
const ALERT_EXCHANGE_BY_CONNECTOR = { Coinbase: 'coinbase', Kraken: 'kraken', Bybit: 'bybit', OKX: 'okx' };
export const alertExchangeFor = (connector) => ALERT_EXCHANGE_BY_CONNECTOR[connector];

export const listAlerts = () => botRequest('/alerts');
export const createAlert = (payload) => botRequest('/alerts', 'POST', payload);
export const updateAlert = (id, payload) => botRequest('/alerts/' + encodeURIComponent(id), 'PUT', payload);
export const toggleAlert = (id) => botRequest('/alerts/' + encodeURIComponent(id) + '/toggle', 'POST');
export const deleteAlert = (id) => botRequest('/alerts/' + encodeURIComponent(id), 'DELETE');
export const retryAlertNotifications = (id) => botRequest('/alerts/' + encodeURIComponent(id) + '/notifications/retry', 'POST');
